<form [formGroup]="holidayValueFormGroup" (ngSubmit)="onSubmit();">

    <h3 class="mb-5 mt-5 col-md-6 underlineTitle ">Cash voor vakantiedagen
        <i placement="top"
                      ngbTooltip="Pas hier parameters aan voor de module Cash voor vakantiedagen"
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
    </h3>

    <div class="form-row h-100">


        <div class="col-md-5  col-sm-12">

            <div class="form-group">
                <div *ngIf="holidayValueFormGroup.controls.berekeningMaandloon.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Info berekening maandloon:</label>
                <i placement="top"
                ngbTooltip="Geef de gebruiker extra uitleg over de berekening van het maandloon."
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="holidayValue.berekeningMaandloon" formControlName="berekeningMaandloon"
                    name="berekeningMaandloon" id="berekeningMaandloon" class="form-control"
                    rows="3"></textarea>
            </div>
          
        </div>
        <div class="col-md-5 col-sm-12 mx-auto">
            <div class="form-group">
                <div *ngIf="holidayValueFormGroup.controls.berekeningUurloon.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Info berekening uurloon:</label>
                <i placement="top"
                ngbTooltip="Geef de gebruiker extra uitleg over de berekening van het uurloon."
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="holidayValue.berekeningUurloon" formControlName="berekeningUurloon"
                    name="berekeningUurloon" id="berekeningUurloon" class="form-control" rows="3"></textarea>
            </div>
        </div>
    
    </div>

    
    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming.kleur}"></div>
    <div class="form-row ">
        <div class="col-md-6   col-sm-12 "></div>
        <div class="col-md-6   col-sm-12 ">
            <button [disabled]="!holidayValueFormGroup.valid" class="btn btn-dark btn-lg float-right mt-2"
                type="submit">OPSLAAN</button>
        </div>

    </div>


</form>
